import { SelectItem } from '@wui/common-library'

export const TIMEZONES: SelectItem[] = [
  { label: '-12:00', value: 'Etc/GMT+12' },
  { label: '-11:00', value: 'Pacific/Pago_Pago' },
  { label: '-10:00', value: 'Pacific/Honolulu' },
  { label: '-09:00', value: 'Pacific/Gambier' },
  { label: '-08:00', value: 'Pacific/Pitcairn' },
  { label: '-07:00', value: 'America/Phoenix' },
  { label: '-06:00', value: 'America/Guatemala' },
  { label: '-05:00', value: 'America/Atikokan' },
  { label: '-04:00', value: 'America/Antigua' },
  { label: '-03:00', value: 'America/Araguaina' },
  { label: '-02:00', value: 'America/Noronha' },
  { label: '-01:00', value: 'Atlantic/Cape_Verde' },
  { label: '+00:00', value: 'Africa/Abidjan' },
  { label: '+01:00', value: 'Africa/Algiers' },
  { label: '+02:00', value: 'Africa/Blantyre' },
  { label: '+03:00', value: 'Asia/Baghdad' },
  { label: '+04:00', value: 'Asia/Dubai' },
  { label: '+05:00', value: 'Asia/Aqtobe' },
  { label: '+05:30', value: 'Asia/Kolkata' },
  { label: '+06:00', value: 'Asia/Omsk' },
  { label: '+06:30', value: 'Asia/Yangon' },
  { label: '+07:00', value: 'Asia/Bangkok' },
  { label: '+08:00', value: 'Asia/Shanghai' },
  { label: '+09:00', value: 'Asia/Tokyo' },
  { label: '+09:30', value: 'Australia/Darwin' },
  { label: '+10:00', value: 'Australia/Brisbane' },
  { label: '+11:00', value: 'Asia/Magadan' },
  { label: '+12:00', value: 'Pacific/Fiji' },
  { label: '+13:00', value: 'Pacific/Enderbury' },
  { label: '+14:00', value: 'Pacific/Kiritimati' },
]

export const DEFAULT_TIMEZONE = 'Asia/Baghdad'
